import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { track } from "@/lib/track";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";
import { BrandLockup } from "@/components/Sidebar";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  useEffect(() => { track("pageview", "/login"); }, []);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    api.post("/auth/login", { email, password })
      .then((r) => onLogin(r.data))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || err.message))
      .finally(() => setBusy(false));
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-6"><BrandLockup /></div>
        <form onSubmit={submit} className="bg-slate-900 border border-slate-800 rounded-2xl p-6 shadow-xl">
          <h1 className="font-heading text-lg font-bold text-white flex items-center gap-2"><Lock className="w-4 h-4 text-teal-400" />Sign in</h1>
          <p className="text-[11px] text-slate-500 mt-1">Restricted intelligence platform — authorised MarksMan users only. Illustrative prototype.</p>
          <div className="space-y-3 mt-5">
            <Input type="email" required placeholder="Work email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-slate-800 border-slate-700 text-slate-100 placeholder:text-slate-500 h-10" data-testid="login-email-input" />
            <Input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-slate-800 border-slate-700 text-slate-100 placeholder:text-slate-500 h-10" data-testid="login-password-input" />
          </div>
          {error && <p className="text-[11.5px] text-red-400 mt-3" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy || !email || !password}
            className="w-full h-10 mt-4 bg-teal-600 hover:bg-teal-700 text-white font-semibold" data-testid="login-submit-button">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Sign in
          </Button>
          <p className="text-[10px] text-slate-600 mt-4 text-center">Access is provisioned by your MarksMan administrator. Sessions use secure httpOnly cookies.</p>
        </form>
      </div>
    </div>
  );
}
